module.exports = __webpack_public_path__ + "static/media/CICLO_4_PROSPERIDAD_DIGITAL_2022.f11af8ea.jpg";